import {
	CEZ_STAGE_AUTH_URL,
	DEV_AUTH_URL,
	DRMAX_STAGE_AUTH_URL,
	GASNET_STAGE_AUTH_URL,
	PRIVATBANK_STAGE_AUTH_URL,
} from '@/constants'
import { Environment } from '@/enums'
import { getAppBaseUrl } from '@/utils/origin'

const PROD_AUTH_URL = `${getAppBaseUrl()}/auth`
const DEFAULT_TENANT = 'adastra'

const isIpAddress = (hostname: string) =>
	/^(?:\d{1,3}\.){3}\d{1,3}$/.test(hostname) || hostname.includes(':')

const tenantId = (() => {
	const hostname = window.location.hostname

	if (hostname === 'localhost' || isIpAddress(hostname)) {
		return DEFAULT_TENANT
	}

	return hostname.split('.')[0]
})()

const getAuthUrl = (() => {
	switch (import.meta.env.VITE_DEV_ENV) {
		case Environment.Dev:
			return DEV_AUTH_URL

		case Environment.Cez:
			return CEZ_STAGE_AUTH_URL

		case Environment.Drmax:
			return DRMAX_STAGE_AUTH_URL

		case Environment.Privatbank:
			return PRIVATBANK_STAGE_AUTH_URL

		case Environment.Gasnet:
			return GASNET_STAGE_AUTH_URL

		default:
			return PROD_AUTH_URL
	}
})()

export const appConfig = {
	authUrl: import.meta.env.VITE_AUTH_URL || getAuthUrl,
	apiUrl: import.meta.env.VITE_API_URL,
	clientId: 'mdd-web',
	defaultTenant: DEFAULT_TENANT,
	realm: import.meta.env.VITE_FIX_TENANT || tenantId,
}
